import { Plugin } from 'prosemirror-state'
import { Decoration, DecorationSet } from 'prosemirror-view'
import { EmojiView } from './EmojiView'
import { ANCHOR_DATA_ATTR, EMOJI_PLUGIN_KEY } from './constants'
import { matcher } from './matcher'

export function EmojiPlugin() {
  return new Plugin({
    key: EMOJI_PLUGIN_KEY,
    state: {
      init() {
        return {
          active: false,
          range: null,
          text: null,
        }
      },
      apply(tr) {
        const { selection } = tr
        const noResults = tr.getMeta(EMOJI_PLUGIN_KEY)?.noResults
        if (!noResults && selection.from === selection.to) {
          const match = matcher(selection.$from)

          if (match) {
            return {
              active: true,
              range: match.range,
              text: match.text.slice(1),
            }
          }
        }

        return {
          active: false,
          range: null,
          text: null,
        }
      },
    },
    view(view) {
      return new EmojiView(view)
    },
    props: {
      decorations(editorState) {
        const state = EMOJI_PLUGIN_KEY.getState(editorState)
        if (!state?.active || !state.range) {
          return DecorationSet.empty
        }
        return DecorationSet.create(editorState.doc, [
          Decoration.inline(state.range.from, state.range.to, { [ANCHOR_DATA_ATTR]: 'true' }),
        ])
      },
      handleKeyDown(view, event) {
        const state = EMOJI_PLUGIN_KEY.getState(view.state)
        if (!state?.active) {
          return false
        }
        return ['ArrowDown', 'ArrowUp', 'Enter', 'Tab'].includes(event.key)
      },
    },
  })
}
